// TRN-7538: "Get the mobile app" block of the auth pages (Login, email Registration), moved out of the registration
// form. Two variants: QR codes inside AuthBrandPanel — on desktop the visitor is not on the phone the app goes to —
// and plain store badges under the form, shown only while that panel is hidden (tablet/phone widths).
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';
import i18nContext from 'components/i18n-context';
import { ReactComponent as AppStoreBadge } from 'assets/registration/app-store-badge.svg';
import { ReactComponent as GooglePlayBadge } from 'assets/registration/google-play-badge.svg';
import './AuthMobileApp.scss';

export const AUTH_MOBILE_APP_VARIANTS = {
  QR: 'qr',
  BADGES: 'badges'
};

// TRN-7454: store listings, set per environment like the other REACT_APP_LINK_* links. A store without a link is
// left out, and so is the whole block when neither is set.
const STORES = [
  {
    key: 'appStore',
    link: process.env.REACT_APP_LINK_APP_STORE?.trim(),
    Badge: AppStoreBadge,
    labelKey: 'registration.mobileApp.appStore',
    nameKey: 'registration.mobileApp.appStoreName'
  },
  {
    key: 'googlePlay',
    link: process.env.REACT_APP_LINK_GOOGLE_PLAY?.trim(),
    Badge: GooglePlayBadge,
    labelKey: 'registration.mobileApp.googlePlay',
    nameKey: 'registration.mobileApp.googlePlayName'
  }
].filter(({ link }) => link);

const AuthMobileApp = ({ variant }) => {
  const i18n = useContext(i18nContext);

  if (!STORES.length) {
    return null;
  }

  // New tab, so a half-filled form stays open behind the store page.
  if (variant === AUTH_MOBILE_APP_VARIANTS.QR) {
    return (
      <div className={'auth-mobile-app auth-mobile-app--qr'}>
        <div className={'auth-mobile-app__text'}>
          <p className={'auth-mobile-app__title'}>{i18n.getMessage('registration.mobileApp.title')}</p>
          <p className={'auth-mobile-app__subtitle'}>{i18n.getMessage('registration.mobileApp.scanQr')}</p>
        </div>
        <div className={'auth-mobile-app__codes'}>
          {STORES.map(({ key, link, labelKey, nameKey }) => (
            <a
              key={key}
              href={link}
              target={'_blank'}
              rel={'noreferrer'}
              className={'auth-mobile-app__code'}
              aria-label={i18n.getMessage(labelKey)}
            >
              <span className={'auth-mobile-app__code-tile'}>
                <QRCodeSVG value={link} size={72} marginSize={0} />
              </span>
              <span className={'auth-mobile-app__code-name'}>{i18n.getMessage(nameKey)}</span>
            </a>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={'auth-mobile-app auth-mobile-app--badges'}>
      {STORES.map(({ key, link, Badge, labelKey }) => (
        <a key={key} href={link} target={'_blank'} rel={'noreferrer'} aria-label={i18n.getMessage(labelKey)}>
          <Badge />
        </a>
      ))}
    </div>
  );
};

AuthMobileApp.propTypes = {
  variant: PropTypes.oneOf(Object.values(AUTH_MOBILE_APP_VARIANTS)).isRequired
};

export default AuthMobileApp;
